/**
 * Notice
 */

import * as util from 'js/lib/utilities';

// Callback for dismissed renewal notices
$('html').on('click', '[data-dismiss-renewal-notice]', event => {
  const levelID = $(event.currentTarget).data('dismiss-renewal-notice');
  util.setCookie(`wlion_membership_${levelID}_renewal_notice_dismissed`, 1, 200);
});



// WEBPACK FOOTER //
// ./assets/js/components/notice.js